import { render, staticRenderFns } from "./viewAreaOrder.vue?vue&type=template&id=2b71ce51&scoped=true"
import script from "./viewAreaOrder.vue?vue&type=script&lang=js"
export * from "./viewAreaOrder.vue?vue&type=script&lang=js"
import style0 from "./viewAreaOrder.vue?vue&type=style&index=0&id=2b71ce51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71ce51",
  null
  
)

export default component.exports